import { ActionType, INotification, IStorageImageCallback } from './model'
import { ActionCallback, Nullable } from '../model'

export const changeLangAction = (payload: string): any => ({
  type: ActionType.CHANGE_LANG,
  payload,
})

export const setNotificationAction = (payload: Nullable<INotification>): any => ({
  type: ActionType.SET_NOTIFICATION,
  payload,
})

export const postImageAction = (
  payload: any,
  callback: IStorageImageCallback
): ActionCallback<any, IStorageImageCallback> => ({
  type: ActionType.POST_IMAGE,
  payload,
  callback,
})
